import React from "react";
import TopoTexture from "@/components/TopoTexture";
import { Phone, ArrowRight } from "lucide-react";
import { COMPANY } from "@/data/site";

const FinalCTA = () => {
  return (
    <section data-testid="final-cta" className="py-20 md:py-28 bg-[var(--ct-primary)] text-white relative overflow-hidden">
      <TopoTexture variant="dark" opacity={0.03} />
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <svg viewBox="0 0 800 400" className="w-full h-full">
          <polygon fill="#F5D20A" points="0,400 150,150 300,250 450,80 600,220 800,120 800,400" />
        </svg>
      </div>
      <div className="section-container relative text-center">
        <div className="label-xs text-[var(--ct-secondary)] mb-4">Wyoming's Trusted Movers</div>
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight" style={{ fontFamily: "Outfit" }}>
          Move with confidence.
          <br />
          <span className="text-[var(--ct-secondary)] block mt-2">Get your free quote today.</span>
        </h2>
        <p className="mt-6 text-white/80 max-w-2xl mx-auto leading-relaxed">
          From your first call to the last box unpacked, Crosstown Movers makes moving in Casper, Mills, and
          across Wyoming completely stress-free.
        </p>
        <div className="mt-10 flex flex-wrap gap-4 justify-center">
          <a href="#quote" className="btn-primary" data-testid="final-cta-quote">
            Request Your Free Quote <ArrowRight className="w-4 h-4" />
          </a>
          <a href={`tel:${COMPANY.phoneTel}`} className="btn-outline !text-white !border-white hover:!bg-white hover:!text-[var(--ct-primary)]" data-testid="final-cta-call">
            <Phone className="w-4 h-4" /> {COMPANY.phone}
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
